import { Button } from '@geberit/gdds';

// styles
import styles from './image-gallery.module.scss';

// types
import type { OverlayDefaultProps } from '../types';

// components
import { Headline, Formats, getFontWeight } from 'components/ContentElements/Headline';
import { InnerHtml } from 'components/InnerHtml/inner-html';

// utils
import { useThemeName } from 'utils/hooks/use-theme';

export function Overlay({
  title,
  subtitle,
  emphasize,
  text,
  onClose,
}: Readonly<OverlayDefaultProps>) {
  const themeName = useThemeName();

  return (
    <div className={styles.overlay}>
      <Button
        isIcon
        symbol="Close"
        className={styles.closeIcon}
        stylingType="flat"
        onClick={onClose}
      />
      <div className={styles.overlayWrapper}>
        <Headline
          tag={Formats.h2}
          format={Formats.h3}
          title={title}
          subtitle={subtitle}
          titleFontWeight={getFontWeight(emphasize === 'title', themeName, Formats.h3)}
          subtitleFontWeight={getFontWeight(emphasize === 'subtitle', themeName, Formats.h3)}
          className={styles.headline}
        />
        <InnerHtml as="div" content={text} isGdds />
      </div>
    </div>
  );
}
